import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

export enum NotificationTypes {
  error = "error",
  success = "success",
  warning = "warning",
}

export interface Notification {
  id?: string;
  message: string;
  title: string;
  type: NotificationTypes;
}

interface NotificationsSliceState {
  notifications: Notification[];
}

const initialState: NotificationsSliceState = {
  notifications: [],
};

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      state.notifications.push({ ...action.payload });
    },
    removeNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter(
        (el) => el.id !== action.payload,
      );
    },
  },
});

export const { addNotification, removeNotification } =
  notificationsSlice.actions;

export const showNotification =
  (notification: Notification) => (dispatch: any) => {
    const id = uuidv4();
    dispatch(addNotification({ ...notification, id }));

    setTimeout(() => {
      dispatch(removeNotification(id));
    }, 3000);
  };

export default notificationsSlice.reducer;
